import { APP_VERSION } from '../appVersion'

const VERSION_KEY_RE = /^\d+\.\d+\.\d+$/

/** Only explicit "true" counts as dismissed — "false" / missing = show banner. */
export const isVersionSeen = () => localStorage.getItem(APP_VERSION) === 'true'

export const markVersionSeen = () => {
  localStorage.setItem(APP_VERSION, 'true')
  pruneOldVersionKeys()
}

/** Removes previous semver keys from localStorage (keeps current APP_VERSION). */
export const pruneOldVersionKeys = () => {
  const keysToRemove = []
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i)
    if (key && VERSION_KEY_RE.test(key) && key !== APP_VERSION) {
      keysToRemove.push(key)
    }
  }
  keysToRemove.forEach((key) => localStorage.removeItem(key))
}
